import React from 'react';
import Select, { selectType } from 'Components/Select';

export default function ListOfModels({
  selectedModelList,
  status,
  modelList,
  errors,
  handleRemoveFromList,
  handleSelectFromList,
  getDetailsLink,
}) {
  return (
    <section className='scene_section'>
      <header className='_padding_bottom_20'>List of Models</header>

      <Select
        type={selectType.primarySmall}
        mainWrapperClassName='_width_pc_80 _margin_top_12'
        dropDownClassName='_max_height_120'
        selectionList={modelList}
        multiSelect
        itemNameIndicator={['id', 'name']}
        error={errors.selectedModelList}
        handleSelect={handleSelectFromList}
        placeholder='Id or Name'
      />

      {selectedModelList.length !== 0 && (
        <section className='selected-list'>
          <div className='selected-list__header'>
            <section className='_flex _stretch'>
              <div className='selected-list__header_text _width_pc_14'>ID</div>
              <div className='selected-list__header_text _width_pc_45'>Name</div>
              <div className='selected-list__header_text _width_pc_18'>
                {selectedModelList[0].boatType ? 'Type' : ''}
              </div>
              <div className='selected-list__header_text _width_pc_18'>
                {selectedModelList[0].engineType ? 'Engine Type' : ''}
              </div>
            </section>
            <div className='selected-list__header_text _width_pc_5'>Remove</div>
          </div>
          <div className='selected-list__body'>
            {selectedModelList.map((model, index) => {
              return (
                <div key={model.id} className='selected-list__body_row'>
                  <a href={getDetailsLink(model)} target='_blank' rel="noreferrer" className='_flex _stretch'>
                    <div className='selected-list__body_text _width_pc_14'>{model.id}</div>
                    <div className='selected-list__body_text _width_pc_45'>{model.name}</div>
                    <div className='selected-list__body_text _width_pc_18'>
                      {model.boatType ? model.boatType.replace(/_/, ' ') : ''}
                    </div>
                    <div className='selected-list__body_text _width_pc_18'>
                      {model.engineType ? model.engineType.replace(/_/, ' ') : ''}
                    </div>
                  </a>
                  <div
                    className='selected-list__body_text _width_pc_5 __remove-icon'
                    onClick={handleRemoveFromList(model, index)}
                  />
                </div>
              );
            })}
          </div>
        </section>
      )}
    </section>
  );
}

ListOfModels.defaultProps = {
  selectedModelList: [],
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/New/ListOfModels.jsx